// cs2148 (15/10/2026): o cliente pediu o "Ordenar" da listagem de imóveis sem a opção "Mais Recentes"
// (desc-inclusao). Quem chega com ?ordem=desc-inclusao (links da home) cai na ordem padrão do site.
// Fora da lista, NADA muda.
export const ORDEM_SEM_MAIS_RECENTES = new Set<number>([2148]);

export const ordemSemMaisRecentes = (site: any): boolean => ORDEM_SEM_MAIS_RECENTES.has(Number(site?.id));
